import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { fileUrl } from "@/lib/api";

// Photo carousel: one fixed frame, loops forever, moves on its own every 5 seconds unless the visitor is hovering it.
export const Slideshow = ({ id, urls, caption }) => {
  const [i, setI] = useState(0);
  const [paused, setPaused] = useState(false);
  const n = urls.length;
  useEffect(() => {
    if (n < 2 || paused) return undefined;
    const t = setInterval(() => setI((x) => (x + 1) % n), 5000);
    return () => clearInterval(t);
  }, [n, paused]);
  if (!n) return null;
  const go = (d) => setI((x) => (x + d + n) % n);
  const at = i % n;
  return (
    <figure data-testid={`slideshow-${id}`} onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
      <div className="relative aspect-[16/10] w-full overflow-hidden rounded-[28px] bg-[#131C2E] md:aspect-[16/8]">
        {urls.map((u, k) => (
          <img key={`${u}-${k}`} src={fileUrl(u)} alt={caption ? `${caption} (${k + 1} of ${n})` : `Photo ${k + 1} of ${n}`} loading={k === 0 ? "eager" : "lazy"}
            className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-700 ${k === at ? "opacity-100" : "opacity-0"}`} />
        ))}
        {n > 1 && (
          <>
            <button type="button" data-testid={`slideshow-${id}-prev`} onClick={() => go(-1)} aria-label="Previous photo" className="absolute left-3 top-1/2 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-full shadow-md" style={{ backgroundColor: "rgba(255,255,255,0.88)", color: "#14213D" }}><ChevronLeft className="h-5 w-5" /></button>
            <button type="button" data-testid={`slideshow-${id}-next`} onClick={() => go(1)} aria-label="Next photo" className="absolute right-3 top-1/2 grid h-11 w-11 -translate-y-1/2 place-items-center rounded-full shadow-md" style={{ backgroundColor: "rgba(255,255,255,0.88)", color: "#14213D" }}><ChevronRight className="h-5 w-5" /></button>
            <div className="absolute inset-x-0 bottom-3 flex justify-center gap-1.5">
              {urls.map((u, k) => (
                <button type="button" key={`d-${u}-${k}`} data-testid={`slideshow-${id}-dot-${k}`} onClick={() => setI(k)} aria-label={`Show photo ${k + 1}`}
                  className={`h-2 rounded-full transition-[width,background-color] duration-300 ${k === at ? "w-6" : "w-2"}`} style={{ backgroundColor: k === at ? "#FFFFFF" : "rgba(255,255,255,0.55)" }} />
              ))}
            </div>
          </>
        )}
      </div>
      {caption && <figcaption className="mt-3 font-ui text-sm text-[#B7BFCC]">{caption}</figcaption>}
    </figure>
  );
};
